import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const ModuleHead = ({ content, isShowMore }) => {
    return (
        <div className={styles.bref}>
            <div className={styles.brefHeadTitle}>{content?.name || ''}</div>
            {isShowMore &&
                content.url && (
                    <a href={content.url} target="_blank" className={styles.brefHeadMore}>
                        更多
                    </a>
                )}
        </div>
    );
};

ModuleHead.propTypes = {
    content: PropTypes.object,
    isShowMore: PropTypes.bool,
};

export default errorBoundary(ModuleHead);
